import {
  BenefitDto,
  CoverageDto,
} from 'enrollment/queries/useBenefitPlansQuery/types';
import { BenefitRestrictions } from 'enrollment/queries/useRestrictionsQuery/types';
import { isCoverageDeclined } from '../common/Utils';
import { CategoryCoverageDto } from 'enrollment/queries/useBenefitCategoryQuery/types';

interface LifeEventRestrictionsProps {
  lifeEventRestrictions: BenefitRestrictions | BenefitRestrictions[];
  orgBenefit: BenefitDto;
  currentCoverage: CoverageDto | CategoryCoverageDto | undefined;
}

//taken from ps_spyder. modified types
export class LifeEventRestriction {
  restriction: BenefitRestrictions | undefined;
  coverage: CoverageDto | CategoryCoverageDto | undefined;
  constructor({
    lifeEventRestrictions,
    orgBenefit,
    currentCoverage = undefined,
  }: LifeEventRestrictionsProps) {
    const orgBenefitId = orgBenefit ? orgBenefit.org_benefit_id : null;

    if (!lifeEventRestrictions) {
      return;
    }
    this.restriction = undefined;
    this.coverage = currentCoverage;

    if (Array.isArray(lifeEventRestrictions)) {
      const benefitRestrictions = lifeEventRestrictions
        ? lifeEventRestrictions.filter(
            (x) => Number(x.org_benefit_id) === Number(orgBenefitId)
          )
        : null;
      this.restriction = benefitRestrictions
        ? benefitRestrictions[0]
        : undefined;
    } else {
      if (lifeEventRestrictions.org_benefit_id === orgBenefitId) {
        this.restriction = lifeEventRestrictions;
      }
    }
  }

  get canElect() {
    return !this.hasCoverage && this.notRestricted('elect');
  }

  get canChangePlan() {
    return this.hasCoverage && this.notRestricted('plan_change');
  }

  get canIncrease() {
    return this.canElect || this.notRestricted('increase');
  }

  get canDecrease() {
    return this.canElect || this.notRestricted('decrease');
  }

  get canChangeOrElect() {
    return this.canChangePlan || this.canElect;
  }

  get canViewOnly() {
    return !this.canChangeOrElect && !this.canIncrease && !this.canDecrease;
  }

  get hasCoverage() {
    return this.coverage && !isCoverageDeclined(this.coverage);
  }

  notRestricted(key: keyof BenefitRestrictions) {
    if (this.restriction) {
      return Boolean(this.restriction[key]);
    }
    return true;
  }
}
